.modal-gallery {
  background-color: #fff;
}
.modal-gallery .modal-content {
  padding: 0;
  height: 100vh;
  max-width: inherit;
}
.modal-gallery .modal-close {
  color: #000;
}